import { createActionCreator } from "deox";

import { AccountStatement } from "../../../types/types";
export const balanceLoading = createActionCreator("balanceLoading");
export const balanceError = createActionCreator("balanceError");

export const balanceSuccess = createActionCreator(
  "balanceSuccess",
  (resolve) => (accountBalance: AccountStatement) => resolve(accountBalance)
);

export const accountBalanceLoading = createActionCreator("accountBalanceLoading");
export const accountBalanceError = createActionCreator("accountBalanceError");

export const accountBalanceSuccess = createActionCreator(
  "accountBalanceSuccess",
  (resolve) => (accountBalance: number) => resolve(accountBalance)
);
export const resetAccountBalance = createActionCreator("resetAccountBalance");
